import { render, staticRenderFns } from "./AssignOrder.vue?vue&type=template&id=101428e0&"
import script from "./AssignOrder.vue?vue&type=script&lang=js&"
export * from "./AssignOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports